import { Fragment, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AiOutlinePlus, AiOutlineMinus } from "react-icons/ai";

import { matchSkuPriceTiering } from "../../services/sku";

import {
  increaseQuantity,
  decreaseQuantity,
  removeFromCart,
  removeBundleFromCart,
} from "../../redux/cart";
import { selectMechanicId } from "../../redux/mechanic";

import { MECHANIC_SKU_PRICE_TIERING_TYPE } from "../../constants/mechanic";

import ConfirmModal from "../ui/Modal/ConfirmModal";

const QuantityControls = (props) => {
  const { product, removeOnLessOne, index, isBundle } = props; // product is the product from cart store

  const [isMatchPriceTiersLoading, setIsMatchPriceTiersLoading] =
    useState(false);
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);

  const dispatch = useDispatch();
  const selectedMechanicId = useSelector(selectMechanicId);

  function openConfirmModal() {
    setIsConfirmModalOpen(true);
  }

  function closeConfirmModal() {
    setIsConfirmModalOpen(false);
  }

  function shouldOpenConfirmModal(isIncrease) {
    if (
      product.skuPriceTieringType === MECHANIC_SKU_PRICE_TIERING_TYPE.RANGE &&
      isIncrease &&
      product.quantity === product.maxAvailableQuantityForPriceTiering &&
      product.priceTierList.find(
        (priceTier) => priceTier.minQuantity && !priceTier.maxQuantity
      )
    ) {
      return true;
    }

    return false;
  }

  async function matchPriceTiers(quantity) {
    try {
      setIsMatchPriceTiersLoading(true);
      const res = await matchSkuPriceTiering(product.id, {
        mechanicId: selectedMechanicId,
        quantity,
      });
      const {
        data: { data },
      } = res;
      return data;
    } catch (err) {
      console.error(err);
    } finally {
      setIsMatchPriceTiersLoading(false);
    }
  }

  async function onIncreaseQuantityWithoutDiscountConfirm() {
    const priceTiersData = await matchPriceTiers(product.quantity + 1);
    const actionPayload = { skuId: product.id, priceTiersData };
    dispatch(increaseQuantity(actionPayload));
    closeConfirmModal();
  }

  async function quantityChangedHandler(changeBy) {
    let actionPayload = {};
    let isIncrease = changeBy === 1;
    let isDecrease = changeBy === -1;
    let isRemove = isDecrease && product.quantity <= 1 && removeOnLessOne;
    let newQuantity = product.quantity + changeBy;

    if (isBundle) {
      actionPayload.bundleId = product.id;
    } else {
      actionPayload.skuId = product.id;
    }

    if (actionPayload.skuId && product.hasPriceTiers && newQuantity > 0) {
      if (shouldOpenConfirmModal(isIncrease)) {
        openConfirmModal();
        return;
      }
      const priceTiersData = await matchPriceTiers(newQuantity);
      actionPayload.priceTiersData = priceTiersData;
    }

    if (isIncrease) {
      dispatch(
        increaseQuantity(product.id ? actionPayload : { skuIndex: index })
      );
    } else if (isRemove && isBundle) {
      dispatch(removeBundleFromCart(product.id));
    } else if (isRemove && !isBundle) {
      dispatch(removeFromCart(actionPayload));
    } else {
      dispatch(
        decreaseQuantity(product.id ? actionPayload : { skuIndex: index })
      );
    }
  }

  return (
    <Fragment>
      <div className="flex flex-col justify-center items-center gap-4">
        {!product.skuList && (
          <>
            {product.maximumQuantityForExpressForSku !== null && (
              <div className="mt-2 text-red-600 text-sm font-medium">
                تنبيه: لا يمكن الطلب السريع لأكثر من{" "}
                {product.maximumQuantityForExpressForSku} قطع
              </div>
            )}
            {product.maximumQuantityForExpressForSku === null &&
              product.maximumQuantityForExpressForSkuName && (
                <div className="mt-2 text-blue-600 text-sm font-medium">
                  تنبيه لا يمكن الطلب السريع لاكثر من{" "}
                  {product.maximumQuantityForExpressForSkuName} قطع من نفس فئة{" "}
                  {product.name}
                </div>
              )}
          </>
        )}

        <div className="flex justify-end items-end">
          <button
            className="mr-auto p-1 rounded bg-dark-blue text-white"
            onClick={quantityChangedHandler.bind(null, 1)}
            disabled={isMatchPriceTiersLoading}
          >
            <AiOutlinePlus />
          </button>

          <span className="mr-8 text-lg font-semibold">{product.quantity}</span>

          <button
            className="mr-8 p-1 rounded bg-dark-blue text-white disabled:bg-light-gray disabled:cursor-not-allowed"
            onClick={quantityChangedHandler.bind(null, -1)}
            disabled={
              isMatchPriceTiersLoading ||
              (product.quantity <= 1 && !removeOnLessOne)
            }
          >
            <AiOutlineMinus />
          </button>
        </div>

        <ConfirmModal
          isOpen={isConfirmModalOpen}
          onOk={onIncreaseQuantityWithoutDiscountConfirm}
          onCancel={closeConfirmModal}
          message={`الكمية فوق ${product.maxAvailableQuantityForPriceTiering} هتكون بسعر القطعة العادي = ${product.inventoryPrice}`}
        />
      </div>
    </Fragment>
  );
};

export default QuantityControls;
